export default "__VITE_ASSET__14116f00__"